var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 29.3334H20.0001C26.6667 29.3334 29.3334 26.6667 29.3334 20V12C29.3334 5.33335 26.6667 2.66669 20.0001 2.66669H12.0001C5.33341 2.66669 2.66675 5.33335 2.66675 12V20C2.66675 26.6667 5.33341 29.3334 12.0001 29.3334Z",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13.3333C13.4727 13.3333 14.6666 12.1394 14.6666 10.6667C14.6666 9.19391 13.4727 8 11.9999 8C10.5272 8 9.33325 9.19391 9.33325 10.6667C9.33325 12.1394 10.5272 13.3333 11.9999 13.3333Z",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56006 25.2666L10.1334 20.8533C11.1867 20.1466 12.7067 20.2266 13.6534 21.04L14.0934 21.4266C15.1334 22.32 16.8134 22.32 17.8534 21.4266L23.4001 16.6666C24.4401 15.7733 26.1201 15.7733 27.1601 16.6666L29.3334 18.5333",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.adb98d2c8cccc91ffdee8a66304f39ed.svg";
export { ForwardRef as ReactComponent };